const bessData = {
  id: "atp-105kwh-bess",
  name: "Outdoor Air-Cooled PV-ESS Cabinet",
  subtitle: "Atom Power ATP 105 kWh Energy Storage System",
  description: [
    {
      title: "",
      text: "The Atom Power ATP 105 kWh is a high-performance, outdoor, air-cooled photovoltaic energy storage system designed for commercial and industrial applications. Built with advanced Lithium Iron Phosphate (LFP) battery technology and a 50kW built-in hybrid inverter, it delivers reliable, long-life, and efficient backup and energy management across diverse operating environments.",
    },
  ],
  image: "bess-banner.png",
  productOverview: {
    image: "/assets/img/product-3/atp-105kwh-bess.png",
    imageAlt: "Atom Power ATP 105 kWh outdoor energy storage cabinet",
    eyebrow: "Industrial Energy Solution",
    title: "ATP 105 kWh BESS",
    price: "Rs.148,000.00",
    compareAtPrice: "Rs.158,000.00",
    discountText: "Save 6%",
    note: "Tax included. Shipping calculated at checkout.",
    actions: [
      { label: "ADD TO CART", variant: "outline" },
      { label: "BUY IT NOW", to: "/contact", variant: "solid" },
    ],
    specs: [
      { label: "Volt", value: "374.4 Volts" },
      { label: "Capacity", value: "117.56 kWh" },
      {
        label: "Life Cycles",
        value: "8000 cycles (0.5P, 5%-95%DOD, 70%SOH)",
      },
      { label: "Warranty", value: "5 years" },
    ],
  },
  gallery: [
    {
      src: "assets/img/product-3/atp-105kwh-gallery-img-3.png",
      alt: "ATP 105kWh BESS - Industrial Energy Storage",
    },
    {
      src: "assets/img/product-3/atp-105kwh-gallery-img-2.webp",
      alt: "ATP 105kWh BESS - Industrial Power Redefined",
    },
    {
      src: "assets/img/product-3/atp-105kwh-gallery-img-1.webp",
      alt: "ATP 105kWh BESS - Smart Energy Solution",
    },
  ],
  systemConfig: {
    "Isolation Method": "Non-Isolation (Transformer Optional)",
    Expandability: "Optional PV DC/DC Converters",
    "Fast Switching":
      "Optional STS (Static Transfer Switch) for seamless power transfer",
  },
  specifications: {
    "Main Parameters": {
      "Battery Type": "Lithium Iron Phosphate (LFP)",
      "Rated Energy Capacity": "105 kWh",
      "Battery Rated Voltage": "374.4 V",
      "Battery Voltage Range": "351 V ~ 421.2 V",
      "Cell Capacity": "280 Ah",
      "Battery Life Cycle": "8000 cycles @ 0.5P (5%~95% DoD, 70% SOH)",
      "Energy Cycle Efficiency": "≥ 88%",
    },
    "Charge / Discharge": {
      "Standard Charge / Discharge Rate": "0.5P",
      "Peak Configuration": "1P1T7S",
      "Depth of Discharge (DoD)": "~90%",
    },
    "Built-In Hybrid Inverter (AC Side)": {
      "Rated AC Power": "50 kW",
      "Maximum AC Power": "55 kW",
      "Maximum Current": "80 A",
      "Rated AC Voltage": "230 V / 400 V",
      "Voltage Range": "±15%",
      "Output Wiring": "3P / N",
      "Rated Frequency": "50 / 60 Hz",
      "Power Factor": "≥ 0.99 (-1 to +1)",
      "Current Harmonic Distortion (THDi)": "< 3%",
      "Overload Capacity": "110%",
      "Maximum Efficiency": "97.8%",
    },
    "Cooling & Thermal Management": {
      "Cooling Method": "Intelligent Air-Cooling System",
      Benefit:
        "Actively reduces battery temperature to enhance performance and extend lifespan",
    },
    Environment: {
      "Protection Rating": "IP54",
      "Operating Temperature Range": "-30°C to 55°C (≥45°C derating)",
      "Relative Humidity": "0% ~ 95% (Non-condensing)",
      "Altitude Limit": "< 2000 m (≥1000 m derating)",
      "Corrosion Resistance": "C3 (C4 / C5 optional)",
      "Fire Protection": "Aerosol",
    },
    "Connectivity & Communication": {
      "BMS Communication": "CAN 2.0b",
      "EMS Communication": "4G / CAN / RS485",
    },
    Mechanical: {
      "Dimensions (W × D × H)": "1310 × 800 × 1540 mm",
      Weight: "Approx. 1.6 Tons",
      Installation: "Outdoor Cabinet System",
    },
    "Warranty & Reliability": {
      Warranty: "5 Years",
      "Annual Degradation Rate": "< 3%",
    },
  },
  features: [
    {
      title: "High Energy Density & Long Life",
      description:
        "105kWh LFP battery with up to 8000 cycles for long-term reliability.",
      iconName: "FaBatteryFull",
    },
    {
      title: "Commercial-Grade Power",
      description: "Integrated 50kW hybrid inverter supports heavy AC loads.",
      iconName: "FaBolt",
    },
    {
      title: "Clean Backup Power",
      description:
        "Eco-friendly alternative to diesel generators with zero emissions and fuel dependency.",
      iconName: "FaLeaf",
    },
    {
      title: "High Depth of Discharge",
      description:
        "Enables maximum usable energy without compromising battery health.",
      iconName: "FaChargingStation",
    },
    {
      title: "Zero Maintenance",
      description:
        "Lithium technology eliminates routine maintenance required by lead-acid systems.",
      iconName: "FaTools",
    },
    {
      title: "All-Weather Performance",
      description:
        "Designed for stable operation in harsh outdoor and industrial environments.",
      iconName: "FaShieldAlt",
    },
  ],
};

export default bessData;
